import { useMemo } from 'react'
import { DashBoardValue } from 'features/dashBoard/hooks'
import { DashBoardItemOption } from 'features/dashBoard/types'
import { GraphOptions, getAxisDef, getValueDef } from '../../common'

import { TargetListResult } from "interface/search/targetList"

export const SunburstGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis',
      type: 'axis',
      label: '軸',
      suffix: 'ごとの'
    },
    {
      id: 'value',
      type: 'value',
      label: '値'
    }
  ]
]

type useSunburstGraphOptionProps<T> = {
  dashBoard: DashBoardValue<T>
  options?: DashBoardItemOption[]
  targetList?: TargetListResult
}
export const useSunburstGraphOption = <T,>({
  dashBoard: {
    configure,
    globalAxisKey
  },
  options,
  targetList
}: useSunburstGraphOptionProps<T>) => useMemo(
  () => ({
    configure, options, targetList,
		axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
		valueDef: getValueDef(configure, options, 'value', targetList)
  }),
  [options, configure, globalAxisKey, targetList]
)
